// Activities bank - organized by category for inspiring users to plan experiences
// Each activity has:
//   - name: Display name
//   - category: Category key
//   - emoji: Display emoji
//   - suggestedDuration: Suggested duration in hours (for single-day events)
//   - suggestedDays: Number of days (for multi-day events, overrides suggestedDuration)
//   - suggestedAllDay: Whether to mark as all-day event
//   - startHour: Suggested start hour (0-23) for timed events
export const activities = [
  // Trips
  { name: 'Beach Day', category: 'trips', emoji: '🏖️', suggestedDuration: 8, suggestedAllDay: true, startHour: 9 },
  { name: 'Mountain Hike', category: 'trips', emoji: '⛰️', suggestedDuration: 6, suggestedAllDay: false, startHour: 7 },
  { name: 'City Break', category: 'trips', emoji: '🏙️', suggestedDays: 3, suggestedAllDay: true },
  { name: 'Road Trip', category: 'trips', emoji: '🚗', suggestedDays: 4, suggestedAllDay: true },
  { name: 'Camping Weekend', category: 'trips', emoji: '🏕️', suggestedDays: 2, suggestedAllDay: true },
  { name: 'National Park Visit', category: 'trips', emoji: '🏞️', suggestedDuration: 8, suggestedAllDay: true, startHour: 8 },
  { name: 'Island Getaway', category: 'trips', emoji: '🏝️', suggestedDays: 5, suggestedAllDay: true },
  { name: 'Ski Trip', category: 'trips', emoji: '⛷️', suggestedDays: 3, suggestedAllDay: true },
  { name: 'Safari Adventure', category: 'trips', emoji: '🦁', suggestedDays: 7, suggestedAllDay: true },
  { name: 'Backpacking Trip', category: 'trips', emoji: '🎒', suggestedDays: 5, suggestedAllDay: true },
  { name: 'Lake House', category: 'trips', emoji: '🛶', suggestedDays: 3, suggestedAllDay: true },
  { name: 'Desert Adventure', category: 'trips', emoji: '🏜️', suggestedDays: 2, suggestedAllDay: true },

  // Experiences
  { name: 'Concert', category: 'experiences', emoji: '🎤', suggestedDuration: 4, suggestedAllDay: false, startHour: 19 },
  { name: 'Escape Room', category: 'experiences', emoji: '🔐', suggestedDuration: 2, suggestedAllDay: false, startHour: 14 },
  { name: 'Cooking Class', category: 'experiences', emoji: '👨‍🍳', suggestedDuration: 3, suggestedAllDay: false, startHour: 18 },
  { name: 'Wine Tasting', category: 'experiences', emoji: '🍷', suggestedDuration: 3, suggestedAllDay: false, startHour: 15 },
  { name: 'Skydiving', category: 'experiences', emoji: '🪂', suggestedDuration: 4, suggestedAllDay: false, startHour: 10 },
  { name: 'Hot Air Balloon', category: 'experiences', emoji: '🎈', suggestedDuration: 3, suggestedAllDay: false, startHour: 6 },
  { name: 'Scuba Diving', category: 'experiences', emoji: '🤿', suggestedDuration: 4, suggestedAllDay: false, startHour: 9 },
  { name: 'Bungee Jump', category: 'experiences', emoji: '🪢', suggestedDuration: 2, suggestedAllDay: false, startHour: 11 },
  { name: 'Spa Day', category: 'experiences', emoji: '💆', suggestedDuration: 6, suggestedAllDay: false, startHour: 10 },
  { name: 'Theater Show', category: 'experiences', emoji: '🎭', suggestedDuration: 3, suggestedAllDay: false, startHour: 19 },
  { name: 'Comedy Night', category: 'experiences', emoji: '😂', suggestedDuration: 3, suggestedAllDay: false, startHour: 20 },
  { name: 'Museum Visit', category: 'experiences', emoji: '🖼️', suggestedDuration: 3, suggestedAllDay: false, startHour: 10 },
  { name: 'Pottery Class', category: 'experiences', emoji: '🏺', suggestedDuration: 2, suggestedAllDay: false, startHour: 14 },
  { name: 'Axe Throwing', category: 'experiences', emoji: '🪓', suggestedDuration: 2, suggestedAllDay: false, startHour: 15 },

  // Friends
  { name: 'Dinner Party', category: 'friends', emoji: '🍽️', suggestedDuration: 4, suggestedAllDay: false, startHour: 18 },
  { name: 'Game Night', category: 'friends', emoji: '🎲', suggestedDuration: 4, suggestedAllDay: false, startHour: 19 },
  { name: 'Movie Marathon', category: 'friends', emoji: '🍿', suggestedDuration: 6, suggestedAllDay: false, startHour: 14 },
  { name: 'Brunch', category: 'friends', emoji: '🥞', suggestedDuration: 2, suggestedAllDay: false, startHour: 11 },
  { name: 'BBQ Party', category: 'friends', emoji: '🍖', suggestedDuration: 5, suggestedAllDay: false, startHour: 14 },
  { name: 'Karaoke Night', category: 'friends', emoji: '🎤', suggestedDuration: 3, suggestedAllDay: false, startHour: 20 },
  { name: 'Picnic', category: 'friends', emoji: '🧺', suggestedDuration: 3, suggestedAllDay: false, startHour: 12 },
  { name: 'Beach Bonfire', category: 'friends', emoji: '🔥', suggestedDuration: 4, suggestedAllDay: false, startHour: 18 },
  { name: 'Rooftop Hangout', category: 'friends', emoji: '🌆', suggestedDuration: 3, suggestedAllDay: false, startHour: 17 },
  { name: 'Trivia Night', category: 'friends', emoji: '🧠', suggestedDuration: 3, suggestedAllDay: false, startHour: 19 },
  { name: 'Pool Party', category: 'friends', emoji: '🏊', suggestedDuration: 5, suggestedAllDay: false, startHour: 13 },
  { name: 'Friendsgiving', category: 'friends', emoji: '🦃', suggestedDuration: 6, suggestedAllDay: false, startHour: 15 },

  // Sports
  { name: 'Tennis Match', category: 'sports', emoji: '🎾', suggestedDuration: 2, suggestedAllDay: false, startHour: 9 },
  { name: 'Surf Session', category: 'sports', emoji: '🏄', suggestedDuration: 3, suggestedAllDay: false, startHour: 7 },
  { name: 'Yoga Class', category: 'sports', emoji: '🧘', suggestedDuration: 1, suggestedAllDay: false, startHour: 8 },
  { name: 'Basketball', category: 'sports', emoji: '🏀', suggestedDuration: 2, suggestedAllDay: false, startHour: 17 },
  { name: 'Soccer Game', category: 'sports', emoji: '⚽', suggestedDuration: 2, suggestedAllDay: false, startHour: 17 },
  { name: 'Rock Climbing', category: 'sports', emoji: '🧗', suggestedDuration: 3, suggestedAllDay: false, startHour: 14 },
  { name: 'Golf Day', category: 'sports', emoji: '⛳', suggestedDuration: 5, suggestedAllDay: false, startHour: 8 },
  { name: 'Cycling Trip', category: 'sports', emoji: '🚴', suggestedDuration: 4, suggestedAllDay: false, startHour: 8 },
  { name: 'Marathon', category: 'sports', emoji: '🏃', suggestedDuration: 6, suggestedAllDay: false, startHour: 7 },
  { name: 'Paddle Boarding', category: 'sports', emoji: '🏄‍♂️', suggestedDuration: 2, suggestedAllDay: false, startHour: 9 },
  { name: 'Volleyball', category: 'sports', emoji: '🏐', suggestedDuration: 2, suggestedAllDay: false, startHour: 16 },
  { name: 'Boxing Class', category: 'sports', emoji: '🥊', suggestedDuration: 1, suggestedAllDay: false, startHour: 18 },
  { name: 'Skiing', category: 'sports', emoji: '⛷️', suggestedDuration: 6, suggestedAllDay: false, startHour: 9 },
  { name: 'Snowboarding', category: 'sports', emoji: '🏂', suggestedDuration: 6, suggestedAllDay: false, startHour: 9 },

  // Work
  { name: 'Conference', category: 'work', emoji: '🎙️', suggestedDays: 2, suggestedAllDay: true },
  { name: 'Workshop', category: 'work', emoji: '🛠️', suggestedDuration: 4, suggestedAllDay: false, startHour: 9 },
  { name: 'Team Building', category: 'work', emoji: '🤝', suggestedDuration: 4, suggestedAllDay: false, startHour: 13 },
  { name: 'Networking Event', category: 'work', emoji: '🤝', suggestedDuration: 3, suggestedAllDay: false, startHour: 18 },
  { name: 'Product Launch', category: 'work', emoji: '🚀', suggestedDuration: 6, suggestedAllDay: false, startHour: 10 },
  { name: 'Hackathon', category: 'work', emoji: '💻', suggestedDays: 2, suggestedAllDay: true },
  { name: 'Offsite Meeting', category: 'work', emoji: '🏢', suggestedDuration: 4, suggestedAllDay: false, startHour: 9 },
  { name: 'Presentation', category: 'work', emoji: '📊', suggestedDuration: 2, suggestedAllDay: false, startHour: 10 },
  { name: 'Client Dinner', category: 'work', emoji: '🍴', suggestedDuration: 3, suggestedAllDay: false, startHour: 18 },
  { name: 'Annual Review', category: 'work', emoji: '📋', suggestedDuration: 1, suggestedAllDay: false, startHour: 14 },

  // Family
  { name: 'Family Dinner', category: 'family', emoji: '🍝', suggestedDuration: 3, suggestedAllDay: false, startHour: 18 },
  { name: 'Birthday Party', category: 'family', emoji: '🎂', suggestedDuration: 4, suggestedAllDay: false, startHour: 14 },
  { name: 'Holiday Gathering', category: 'family', emoji: '🎄', suggestedDuration: 6, suggestedAllDay: false, startHour: 15 },
  { name: 'Kids Day Out', category: 'family', emoji: '🎠', suggestedDuration: 6, suggestedAllDay: false, startHour: 10 },
  { name: 'Family Reunion', category: 'family', emoji: '👨‍👩‍👧‍👦', suggestedDays: 2, suggestedAllDay: true },
  { name: 'Zoo Visit', category: 'family', emoji: '🦒', suggestedDuration: 5, suggestedAllDay: false, startHour: 9 },
  { name: 'Theme Park', category: 'family', emoji: '🎢', suggestedDuration: 8, suggestedAllDay: true, startHour: 9 },
  { name: 'Parents Visit', category: 'family', emoji: '👨‍👩‍👦', suggestedDays: 3, suggestedAllDay: true },
  { name: 'Family Photos', category: 'family', emoji: '📸', suggestedDuration: 2, suggestedAllDay: false, startHour: 10 },
  { name: 'Grandparents Day', category: 'family', emoji: '👴👵', suggestedDuration: 5, suggestedAllDay: false, startHour: 11 },
  { name: 'Anniversary', category: 'family', emoji: '💐', suggestedDuration: 6, suggestedAllDay: false, startHour: 18 },

  // Health
  { name: 'Doctor Checkup', category: 'health', emoji: '🩺', suggestedDuration: 1, suggestedAllDay: false, startHour: 10 },
  { name: 'Dentist', category: 'health', emoji: '🦷', suggestedDuration: 1, suggestedAllDay: false, startHour: 14 },
  { name: 'Therapy Session', category: 'health', emoji: '🛋️', suggestedDuration: 1, suggestedAllDay: false, startHour: 15 },
  { name: 'Meditation Retreat', category: 'health', emoji: '🧘‍♀️', suggestedDays: 3, suggestedAllDay: true },
  { name: 'Wellness Day', category: 'health', emoji: '🌿', suggestedDuration: 8, suggestedAllDay: true, startHour: 8 },
  { name: 'Gym Session', category: 'health', emoji: '💪', suggestedDuration: 1.5, suggestedAllDay: false, startHour: 6 },
  { name: 'Health Screening', category: 'health', emoji: '📋', suggestedDuration: 2, suggestedAllDay: false, startHour: 9 },
  { name: 'Massage', category: 'health', emoji: '💆‍♀️', suggestedDuration: 1.5, suggestedAllDay: false, startHour: 14 },
  { name: 'Detox Week', category: 'health', emoji: '🥗', suggestedDays: 7, suggestedAllDay: true },
  { name: 'Sleep Challenge', category: 'health', emoji: '😴', suggestedDays: 7, suggestedAllDay: true },

  // Learning
  { name: 'Online Course', category: 'learning', emoji: '💻', suggestedDuration: 2, suggestedAllDay: false, startHour: 19 },
  { name: 'Language Class', category: 'learning', emoji: '🗣️', suggestedDuration: 1.5, suggestedAllDay: false, startHour: 18 },
  { name: 'Book Club', category: 'learning', emoji: '📖', suggestedDuration: 2, suggestedAllDay: false, startHour: 19 },
  { name: 'Seminar', category: 'learning', emoji: '🎓', suggestedDuration: 4, suggestedAllDay: false, startHour: 13 },
  { name: 'Certification Exam', category: 'learning', emoji: '📜', suggestedDuration: 3, suggestedAllDay: false, startHour: 9 },
  { name: 'Music Lesson', category: 'learning', emoji: '🎹', suggestedDuration: 1, suggestedAllDay: false, startHour: 16 },
  { name: 'Art Class', category: 'learning', emoji: '🎨', suggestedDuration: 2, suggestedAllDay: false, startHour: 14 },
  { name: 'Coding Bootcamp', category: 'learning', emoji: '👨‍💻', suggestedDays: 5, suggestedAllDay: true },
  { name: 'Photography Walk', category: 'learning', emoji: '📷', suggestedDuration: 3, suggestedAllDay: false, startHour: 16 },
  { name: 'Public Speaking', category: 'learning', emoji: '🎤', suggestedDuration: 2, suggestedAllDay: false, startHour: 18 },
  { name: 'Dance Lesson', category: 'learning', emoji: '💃', suggestedDuration: 1, suggestedAllDay: false, startHour: 19 },

  // Romance
  { name: 'Date Night', category: 'romance', emoji: '💑', suggestedDuration: 4, suggestedAllDay: false, startHour: 18 },
  { name: 'Anniversary Dinner', category: 'romance', emoji: '🌹', suggestedDuration: 4, suggestedAllDay: false, startHour: 19 },
  { name: 'Weekend Getaway', category: 'romance', emoji: '💕', suggestedDays: 2, suggestedAllDay: true },
  { name: 'Sunset Picnic', category: 'romance', emoji: '🌅', suggestedDuration: 3, suggestedAllDay: false, startHour: 17 },
  { name: 'Couples Spa', category: 'romance', emoji: '💑', suggestedDuration: 4, suggestedAllDay: false, startHour: 13 },
  { name: 'Stargazing', category: 'romance', emoji: '✨', suggestedDuration: 3, suggestedAllDay: false, startHour: 21 },
  { name: 'Dancing Night', category: 'romance', emoji: '💃', suggestedDuration: 4, suggestedAllDay: false, startHour: 20 },
  { name: 'Proposal Planning', category: 'romance', emoji: '💍', suggestedDuration: 3, suggestedAllDay: false, startHour: 18 },
  { name: "Valentine's Day", category: 'romance', emoji: '💝', suggestedDuration: 6, suggestedAllDay: false, startHour: 18 },
  { name: 'Love Letter Day', category: 'romance', emoji: '💌', suggestedDuration: 2, suggestedAllDay: false, startHour: 10 },

  // Creativity
  { name: 'Painting Session', category: 'creativity', emoji: '🎨', suggestedDuration: 3, suggestedAllDay: false, startHour: 14 },
  { name: 'Writing Workshop', category: 'creativity', emoji: '✍️', suggestedDuration: 4, suggestedAllDay: false, startHour: 10 },
  { name: 'DIY Project', category: 'creativity', emoji: '🔨', suggestedDuration: 6, suggestedAllDay: false, startHour: 9 },
  { name: 'Photography Day', category: 'creativity', emoji: '📸', suggestedDuration: 5, suggestedAllDay: false, startHour: 8 },
  { name: 'Craft Night', category: 'creativity', emoji: '✂️', suggestedDuration: 3, suggestedAllDay: false, startHour: 19 },
  { name: 'Music Jam', category: 'creativity', emoji: '🎸', suggestedDuration: 3, suggestedAllDay: false, startHour: 19 },
  { name: 'Sculpture Class', category: 'creativity', emoji: '🗿', suggestedDuration: 3, suggestedAllDay: false, startHour: 14 },
  { name: 'Garden Project', category: 'creativity', emoji: '🌱', suggestedDuration: 4, suggestedAllDay: false, startHour: 8 },
  { name: 'Home Makeover', category: 'creativity', emoji: '🏠', suggestedDays: 2, suggestedAllDay: true },
  { name: 'Journaling', category: 'creativity', emoji: '📓', suggestedDuration: 1, suggestedAllDay: false, startHour: 20 },

  // Food
  { name: 'Restaurant Hopping', category: 'food', emoji: '🍴', suggestedDuration: 5, suggestedAllDay: false, startHour: 18 },
  { name: 'Food Festival', category: 'food', emoji: '🎪', suggestedDuration: 6, suggestedAllDay: false, startHour: 12 },
  { name: 'Farmers Market', category: 'food', emoji: '🧑‍🌾', suggestedDuration: 2, suggestedAllDay: false, startHour: 8 },
  { name: 'Baking Day', category: 'food', emoji: '🧁', suggestedDuration: 4, suggestedAllDay: false, startHour: 10 },
  { name: 'Sushi Making', category: 'food', emoji: '🍣', suggestedDuration: 4, suggestedAllDay: false, startHour: 17 },
  { name: 'BBQ Masterclass', category: 'food', emoji: '🍗', suggestedDuration: 4, suggestedAllDay: false, startHour: 14 },
  { name: 'Coffee Tasting', category: 'food', emoji: '☕', suggestedDuration: 2, suggestedAllDay: false, startHour: 10 },
  { name: 'Brewery Tour', category: 'food', emoji: '🍺', suggestedDuration: 3, suggestedAllDay: false, startHour: 14 },
  { name: 'Pizza Night', category: 'food', emoji: '🍕', suggestedDuration: 3, suggestedAllDay: false, startHour: 18 },
  { name: 'Taco Tuesday', category: 'food', emoji: '🌮', suggestedDuration: 2, suggestedAllDay: false, startHour: 18 },
  { name: 'Dim Sum Brunch', category: 'food', emoji: '🥟', suggestedDuration: 2, suggestedAllDay: false, startHour: 11 },

  // Music
  { name: 'Live Concert', category: 'music', emoji: '🎸', suggestedDuration: 4, suggestedAllDay: false, startHour: 19 },
  { name: 'Music Festival', category: 'music', emoji: '🎪', suggestedDays: 3, suggestedAllDay: true },
  { name: 'Open Mic Night', category: 'music', emoji: '🎤', suggestedDuration: 3, suggestedAllDay: false, startHour: 20 },
  { name: 'Jazz Club', category: 'music', emoji: '🎷', suggestedDuration: 3, suggestedAllDay: false, startHour: 20 },
  { name: 'DJ Night', category: 'music', emoji: '🎧', suggestedDuration: 5, suggestedAllDay: false, startHour: 21 },
  { name: 'Vinyl Hunting', category: 'music', emoji: '💿', suggestedDuration: 3, suggestedAllDay: false, startHour: 13 },
  { name: 'Band Practice', category: 'music', emoji: '🥁', suggestedDuration: 2, suggestedAllDay: false, startHour: 19 },
  { name: 'Album Listening Party', category: 'music', emoji: '🎵', suggestedDuration: 3, suggestedAllDay: false, startHour: 19 },
  { name: 'Orchestra Night', category: 'music', emoji: '🎻', suggestedDuration: 3, suggestedAllDay: false, startHour: 19 },
];

export const categoryColors = {
  trips: '#FFB347',
  experiences: '#FF6B6B',
  friends: '#98D8C8',
  sports: '#F7DC6F',
  work: '#BB8FCE',
  family: '#F5A9B8',
  health: '#7FCDCD',
  learning: '#B4D4A8',
  romance: '#FFB6C1',
  creativity: '#DDA0DD',
  food: '#FFDAB9',
  music: '#87CEEB'
};

export const categoryEmojis = {
  trips: '✈️',
  experiences: '🎭',
  friends: '👯',
  sports: '⚽',
  work: '💼',
  family: '👨‍👩‍👧‍👦',
  health: '🏥',
  learning: '📚',
  romance: '💕',
  creativity: '🎨',
  food: '🍕',
  music: '🎵'
};

export const categoryLabels = {
  trips: 'Trips',
  experiences: 'Experiences',
  friends: 'Friends',
  sports: 'Sports',
  work: 'Work',
  family: 'Family',
  health: 'Health',
  learning: 'Learning',
  romance: 'Romance',
  creativity: 'Creativity',
  food: 'Food',
  music: 'Music'
};

export const categoryOrder = [
  'trips', 'experiences', 'friends', 'sports', 'work', 'family',
  'health', 'learning', 'romance', 'creativity', 'food', 'music'
];

// Get activities grouped by category
export const getActivitiesByCategory = () => {
  const grouped = {};
  categoryOrder.forEach(cat => {
    grouped[cat] = activities.filter(a => a.category === cat);
  });
  return grouped;
};

// Celebration messages
export const celebrationMessages = [
  "You're making 2026 epic!",
  "Another adventure awaits!",
  "Life is better with plans!",
  "Your calendar is getting exciting!",
  "Making memories, one event at a time!",
  "That's the spirit!",
  "Adventure unlocked!",
  "Your future self will thank you!",
  "Now we're talking!",
  "Living your best life!",
  "Dreams become plans!",
  "Let's goooo!",
];

export const getRandomMessage = () => {
  return celebrationMessages[Math.floor(Math.random() * celebrationMessages.length)];
};
